export const uploadStatus = Object.freeze({
    INITIAL: 0,
    SAVING: 1,
    SUCCESS: 2,
    FAILED: 3
});